import React from "react";
import call from "../../assets/call.png";
import GetInTouch from "../Home/GetInTouch/GetInTouch";

const TermsConditions = () => {
  return (
    <>
      <div class="hero for-inner">
        <div class="container">
          <div class="hero-grid inner">
            <div class="hero-w-width on-inner">
              <h1 class="display-1">
                Terms And<span class="gray-text-color"> Conditions</span>
              </h1>
            </div>
          </div>
        </div>
      </div>
      <div class="section legal">
        <div class="container">
          <div>
            <div class="leagl-wrapper">
              <div
                data-w-id="eb6b77d4-5c7b-d30c-b6da-7c7144717a91"
                class="legal-wrapper"
              >
                <p>Last updated: 17 Oct 2024</p>
                <div class="margin-30px">
                  <p class="terms-paragraph">
                    <strong>Welcome to Win Migration Group!</strong>
                    These terms and conditions outline the rules and regulations
                    for the use of{" "}
                    <strong>
                      {" "}
                      ORE Migration Services PTY Ltd T/A Win Migration Group's
                    </strong>{" "}
                    website, located at <a>winmigrationgroup.com</a>. By
                    accessing or using this website, you agree to be bound by
                    the following terms and conditions. If you do not agree with
                    any part of these terms, please discontinue your use of the
                    website.
                  </p>
                  <ul role="list">
                    <li class="terms-list-item">
                      “Client,” “You,” and “Your” refer to you, the person
                      accessing this website and accepting the Company’s terms
                      and conditions.
                    </li>
                    <li class="terms-list-item">
                      “The Company,” “Ourselves,” “We,” “Our,” and “Us” refer to{" "}
                      <strong>
                        ORE Migration Services PTY Ltd T/A Win Migration Group.
                      </strong>
                    </li>
                    <li class="terms-list-item">
                      “Party,” “Parties,” or “Us” refers to both the Client and
                      the Company. All terms refer to the offer, acceptance, and
                      consideration of payment necessary to undertake the
                      process of our services in accordance with Australian law.
                    </li>
                  </ul>
                </div>
                <div class="margin-30px">
                  <h4 class="heading-3">
                    <strong>2. Use of Cookies</strong>
                    <br />
                  </h4>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p class="terms-paragraph">
                      We employ the use of cookies to enhance the user
                      experience on our website. By using this website, you
                      consent to the use of cookies in accordance with our
                      Privacy Policy. Cookies help us optimize site
                      functionality and are used to store user preferences and
                      track website interaction.
                    </p>
                  </div>
                </div>
                <div class="margin-30px">
                  <h4>
                    <strong class="bold-text">
                      3. Intellectual Property Rights
                    </strong>
                    <br />
                  </h4>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p class="terms-paragraph">
                      Unless otherwise stated, ORE Migration Services PTY Ltd
                      T/A Win Migration Group and/or its licensors own the
                      intellectual property rights for all materials on this
                      website. All intellectual property rights are reserved.
                      You may access this website for personal use only, subject
                      to the restrictions outlined below.
                    </p>
                    <p>You must not:</p>
                    <ul role="list">
                      <li class="terms-list-item">
                        Republish material from this website.
                      </li>
                      <li class="terms-list-item">
                        Sell, rent, or sub-license material from this website.
                      </li>
                      <li class="terms-list-item">
                        Reproduce, duplicate, or copy material from this
                        website.
                      </li>
                      <li class="terms-list-item">
                        Redistribute content from this website without prior
                        written consent
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="margin-30px">
                  <h4>
                    <strong class="bold-text">4. User Conduct</strong>
                    <br />
                  </h4>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p class="terms-paragraph">
                      You agree to use the website in a lawful manner and not
                      to:
                    </p>
                    <ul role="list">
                      <li class="terms-list-item">
                        Post or transmit any unlawful, threatening, defamatory,
                        obscene, or offensive material
                      </li>
                      <li class="terms-list-item">
                        Use the website for any commercial activities or
                        revenue-generating activities without our prior written
                        consent.
                      </li>
                      <li class="terms-list-item">
                        Attempt to gain unauthorized access to any portion of
                        the website or any related systems.
                      </li>
                      <li class="terms-list-item">
                        Introduce any harmful code, viruses, or malware into the
                        website.
                      </li>
                      <li class="terms-list-item">
                        Use automated means (e.g., robots, data scraping, or
                        screen scraping tools) to access or manipulate content
                        on the website.
                      </li>
                    </ul>
                    <p class="terms-paragraph">
                      We reserve the right to terminate your access to the
                      website if you breach any of these terms.
                    </p>
                  </div>
                </div>
                <div class="margin-30px">
                  <h4>
                    <strong class="bold-text">
                      5. Comments and User-Generated Content
                    </strong>
                    <br />
                  </h4>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p class="terms-paragraph">
                      Certain areas of this website may allow users to post
                      comments or content. We do not endorse, review, or
                      pre-screen comments before they are posted. Comments
                      reflect the views of the individual user and not those of{" "}
                      <strong>
                        ORE Migration Services PTY Ltd T/A Win Migration Group.
                      </strong>
                    </p>
                    <p class="terms-paragraph">
                      By posting comments or content, you represent that:
                    </p>
                    <ul role="list" class="list">
                      <li class="terms-list-item">
                        You have all necessary rights and permissions to post
                        the content.
                      </li>
                      <li class="terms-list-item">
                        The content does not infringe upon any third party's
                        intellectual property rights, including copyrights and
                        trademarks.
                      </li>
                    </ul>
                    <p class="terms-paragraph">
                      We reserve the right to monitor and remove any comments or
                      content that violate these terms.
                    </p>
                  </div>
                </div>

                <div class="margin-30px">
                  <h4>
                    <strong class="bold-text">
                      6. Hyperlinking to Our Content
                    </strong>
                    <br />
                  </h4>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p class="terms-paragraph">
                      We may allow the following organizations to link to our
                      website without prior written approval:
                    </p>
                    <ul role="list" class="list">
                      <li class="terms-list-item">Government agencies</li>
                      <li class="terms-list-item">Search engines</li>
                      <li class="terms-list-item">News organizations</li>
                      <li class="terms-list-item">
                        Online directory distributors
                      </li>
                    </ul>
                    <p className="terms-paragraph">
                      These organizations may link to our home page as long as
                      the link is not deceptive, does not imply sponsorship or
                      endorsement, and fits within the context of the linking
                      party’s site.
                    </p>
                    <p className="terms-paragraph">
                      We may also consider other link requests from
                      organizations such as:
                    </p>
                    <ul role="list" class="list">
                      <li class="terms-list-item">Dot.com community sites</li>
                      <li class="terms-list-item">Professional associations</li>
                      <li class="terms-list-item">
                        Educational institutions and trade associations
                      </li>
                      <p className="terms-paragraph">
                        If you are interested in linking to our website, please
                        contact us for approval.
                      </p>
                    </ul>
                  </div>
                </div>
                <div class="margin-30px">
                  <h4>
                    <strong class="bold-text">7. IFrames</strong>
                    <br />
                  </h4>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p>
                      Without prior approval, you may not create frames around
                      our website that alter its appearance or functionality.
                    </p>
                  </div>
                </div>
                <div class="margin-30px">
                  <h4>
                    <strong class="bold-text">8. Content Liability</strong>
                    <br />
                  </h4>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p>
                      We are not responsible for any content appearing on
                      websites that link to our site. You agree to defend and
                      protect us from any claims related to content displayed on
                      your website that links to ours. No link to our website
                      should appear on any site that may be interpreted as
                      libelous, obscene, or unlawful.
                    </p>
                  </div>
                </div>
                <div class="margin-30px">
                  <h4>
                    <strong class="bold-text">9. Reservation of Rights</strong>
                    <br />
                  </h4>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p>
                      We reserve the right to request that you remove any links
                      to our website or specific content at our discretion. You
                      agree to remove all links to our website upon request. We
                      also reserve the right to update or amend these terms at
                      any time, and continued use of our website constitutes
                      your acceptance of those changes.
                    </p>
                  </div>
                </div>
                <div class="margin-30px">
                  <h4>
                    <strong class="bold-text">10. Removal of Links</strong>
                    <br />
                  </h4>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p>
                      If you find any links on our website that you believe are
                      inappropriate or offensive, you are welcome to notify us.
                      We will review requests to remove links but are not
                      obligated to do so.
                    </p>
                  </div>
                </div>
                <div class="margin-30px">
                  <h4>
                    <strong class="bold-text">11. Disclaimer</strong>
                    <br />
                  </h4>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p>
                      To the maximum extent permitted by law, we exclude all
                      representations, warranties, and conditions relating to
                      this website and your use of it. We do not guarantee that
                      the website will be free from errors or that any
                      information provided is complete or up-to-date.
                    </p>
                    <p>
                      Nothing in this disclaimer limits or excludes liability
                      for death or personal injury, fraud, or any liability that
                      cannot be excluded under applicable law. As long as the
                      website and its content are provided free of charge, we
                      will not be liable for any loss or damage of any kind.
                    </p>
                  </div>
                </div>
                <div class="margin-30px">
                  <h4>
                    <strong class="bold-text">12. Payments</strong>
                    <br />
                  </h4>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p>
                      Payments made through the website will appear under the
                      merchant name "Win Migration Group" on your card
                      statement. All payments made are final, and refunds will
                      be provided only under the terms outlined in our service
                      agreements.
                    </p>
                  </div>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p>
                      ORE Migration Services PTY Ltd T/A Win Migration Group ABN
                      11 640 885 623
                    </p>
                    <p>
                      Email:
                      <a href="mailto:contact@winmigrationgroup.com">
                        contact@winmigrationgroup.com
                      </a>
                    </p>
                    <p>Last updated: 17 Oct 2024</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <GetInTouch />
    </>
  );
};

export default TermsConditions;
